import { numberUtils } from '@pukka/common/utils';
import { Modal, Text } from '@pukka/ui-components';

interface PaymentGatewayErrorProps {
  readonly open: boolean;
  readonly totalPayment?: number;
  readonly onClose: () => void;
}

function PaymentGatewayErrorModal({ open, totalPayment, onClose }: PaymentGatewayErrorProps) {
  return (
    <Modal open={open}>
      <Modal.Title>Payment</Modal.Title>
      <Modal.Body data-testid="payment-gateway-error">
        <div className="flex justify-between">
          <Text variant="title-2" color="blue" weight="bold">
            Total Payment
          </Text>
          <Text variant="title-2" color="blue" weight="bold">
            Rp {numberUtils.formatCurrency(totalPayment)}
          </Text>
        </div>
        <br />
        <Text>
          We are having a technical issue with our payment gateway. Please try again in a few moment or if the issue still persist please
          call our support{' '}
          <Text as="a" href="tel:1500970" color="blue" className="hover:underline">
            1500 970
          </Text>
          .
        </Text>
      </Modal.Body>
      <Modal.Footer
        onCancel={false}
        buttons={
          <Modal.Button variant="secondary" onClick={onClose}>
            Close
          </Modal.Button>
        }
      />
    </Modal>
  );
}

export { PaymentGatewayErrorModal };
